import React, { useState, useEffect } from "react";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import AddIcon from '@mui/icons-material/Add';
import rightarrow from '../../Assets/navbar/right-arrow.svg'
import { useLocation, useNavigate } from "react-router-dom";
import img6 from '../../Assets/add/img6.png'
import { Alert } from '@mui/material';
import { ChevronDown, ChevronUp } from 'lucide-react';
import rightArrow from "../../Assets/navbar/right-arrow.svg";
import { Trash, Trash2, CheckCircle, XCircle } from 'lucide-react';
import { State, City } from "country-state-city";

// import img6 from '../../Assets/home/img4.png'

const ViewAndApproveVendor = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    console.log("Received:", state?.mobileNo);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [isLoadingStates, setIsLoadingStates] = useState(true);
    const [currentVendorId, setCurrentVendorId] = useState(null);

    const [isLoadingCities, setIsLoadingCities] = useState(true);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const [isOpenImage, setIsOpenImage] = useState({});
    const [storedVehicleNos, setStoredVehicleNos] = useState([]);
    const [tempVehicleNo, setTempVehicleNo] = useState("");
    const [data, setData] = useState({});
    const [modalImage, setModalImage] = useState(null)
    // temporary input
    const [formData, setFormData] = useState({
        loginMobile: '',
        vehicleNo: [],
        vendorName: "",
        city: "",
        state: "",
        vendorPhone: "",
        fatherName: '',
        address: '',
        companyName: '',
        ReasonOfRejection: "",
        chooseFromSelectedService: null,
        subType: null,
        driverNames: '',
        driverNumbers: '',
        driverDOBs: '',
        driverDLNos: '',
        currentStatus: "",
        ReasonOfRejectionKYC: "",
        allReasonsOfRejection: "",
        typeOfAgreement: '',
        vendorType:''
    });
    console.log('formdata123', formData)
    const [images, setImages] = useState({});
    const [newImages, setNewImages] = useState({});

    console.log('images', images)

    const getDataById = async (id) => {
        try {
            console.log(`${process.env.REACT_APP_BACKEND_URL}/api/data/${id}`)
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/data/${id}`
            );
            const fetchedData = response.data;
            console.log('fetched', fetchedData.data)
            setData(fetchedData.data); // Save raw if needed

            console.log('fetchedData.vehicleNo', fetchedData?.data?.driverDLNos)
            console.log('fetchedData.companyName', fetchedData?.data?.companyName)

            // Prefill form fields
            setFormData({
                vehicleNo: fetchedData?.data?.vehicleNo?.split(',') || "",
                vendorName: fetchedData?.data?.vendorName || "",
                vendorPhone: fetchedData?.data?.vendorPhone || "",
                fatherName: fetchedData?.data?.fatherName || "",
                address: fetchedData?.data?.address || "",
                state: fetchedData?.data?.state || "",
                city: fetchedData?.data?.district || "",
                companyName: fetchedData?.data?.companyName || "",
                typeOfAgreement: fetchedData?.data?.typeOfAgreement,
                vendorType: fetchedData?.data?.vendorType,
                driverNames: fetchedData?.data?.driverNames,
                driverNumbers: fetchedData?.data?.driverNumbers,
                driverDOBs: fetchedData?.data?.driverDOBs,
                driverDLNos: fetchedData?.data?.driverDLNos,
                currentStatus: fetchedData?.data?.currentStatus,
                ReasonOfRejectionKYC: fetchedData?.data?.ReasonOfRejectionKYC,
                allReasonsOfRejection: fetchedData?.data?.allReasonsOfRejection,

            });

            // Prefill image fields
            const initialImages = {};
            const keys = [];

            console.log('fetchedData?.data?.images', fetchedData?.data?.images)
            if (fetchedData?.data?.images) {
                for (const [key, value] of Object.entries(fetchedData?.data?.images)) {
                    if (value) {
                        initialImages[key] = value;
                        keys.push(key);
                    }
                }
                console.log('initialImages', initialImages);
            }

            setImages(initialImages);
            setImageKeys(keys);
            // setTypeOfAgreement(fetchedData.data.typeOfAgreement || "individual");
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        if (
            formData.driverNames &&
            formData.driverNumbers && formData.driverDLNos && formData.driverDOBs &&
            Array.isArray(formData.vehicleNo) &&
            formData.vehicleNo.length > 0
        ) {
            const prefilledData = {};
            formData.vehicleNo.forEach((vehicle) => {
                prefilledData[`driverName-${vehicle}`] = formData.driverNames[vehicle] || "";
                prefilledData[`driverNumber-${vehicle}`] = formData.driverNumbers[vehicle] || "";
                prefilledData[`driverDLNos-${vehicle}`] = formData.driverDLNos[vehicle] || "";
                prefilledData[`driverDOBs-${vehicle}`] = formData.driverDOBs[vehicle] || "";


            });

            setFormData((prev) => ({
                ...prev,
                ...prefilledData,
            }));
        }
    }, [formData.driverNames, formData.driverNumbers, formData.driverDLNos, formData.driverDOBs, formData.vehicleNo]);



    // Fetch on mount
    useEffect(() => {
        console.log('state?.id', state?.id)
        if (state?.id) {
            getDataById(state?.id);
            setCurrentVendorId(state?.id)
        }

    }, [state]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOpenFor, setIsOpenFor] = useState(null);

    const [nextPage, setNextPage] = useState(1);
    useEffect(() => {
        if (formData.currentStatus == 1) {
            setNextPage(3);
        }
    }, [formData])
    const [submittedVehicles, setSubmittedVehicles] = useState([]);

    const [imageKeys, setImageKeys] = useState([
        "Photo of the Owner",
        "Adhar Card Front",
        "Adhar Card Back",
        "Pan Card",
        "GST",
        "Cancelled cheque",
        "RC",
        "Insurance",
        "Front Vehicle",
        "Rear Vehicle",
        "Right Side",
        "Left Side",


        ...Array.from({ length: 0 }, (_, i) => `image${i + 1}`),
    ]);

    const [imageKeysForVehicle, setImageKeysForVehicle] = useState([
        "RC",
        "Insurance",
        "Front Vehicle",
        "Rear Vehicle",
        "Right Side",
        "Left Side",
    ])

    const [imageKeysCompany, setImageKeysCompany] = useState([
        "Photo of the Owner",
        "Adhar Card Front",
        "Adhar Card Back",
        "Pan Card",
        "GST",
        "Cancelled cheque",
        "RC",
        "Insurance",
        "Front Vehicle",
        "Rear Vehicle",
        "Right Side",
        "Left Side",
        "MOA",
        "Partnership Deed or Company Registration Certificate",

        ...Array.from({ length: 0 }, (_, i) => `image${i + 1}`),
    ]);

    const [isSubmitting, setIsSubmitting] = useState(false);






    const loadStates = () => {
        setIsLoadingStates(true);

        try {
            const allStates = State.getStatesOfCountry("IN");
            setStates(allStates);
        } catch (error) {
            console.error("Error loading states:", error);
        } finally {
            setIsLoadingStates(false);
        }
    }


    const loadCities = (stateCode) => {
        setIsLoadingCities(true);

        try {
            const allCities = City.getCitiesOfState("IN", stateCode);
            setCities(allCities);
        } catch (error) {
            console.error("Error loading cities:", error);
        } finally {
            setIsLoadingCities(false);
        }
    };



    // useEffect(() => {
    //     console.log('state?.mobileNo', state?.mobileNo)
    //     loadStates();
    //     if (state?.mobileNo) {
    //         setFormData(prev => ({
    //             ...prev,
    //             login_mobile: state?.mobileNo
    //         }))
    //     }
    //     const hasVisited = sessionStorage.getItem("hasVisitedModal");
    //     if (!hasVisited) {
    //         setIsModalOpen(true); // show modal on first visit
    //         sessionStorage.setItem("hasVisitedModal", "true"); // set flag so it won't show again
    //     }
    // }, [state]);



    const [rejectedObject, setRejectedObject] = useState({});
    console.log('rejectedObject', rejectedObject)
    let clickTimeout = null;

    const formatLabel = (key) => {
        // Converts camelCase or snake_case to "Title Case"
        return key
            .replace(/([A-Z])/g, ' $1')         // insert space before caps
            .replace(/[_-]/g, ' ')              // replace _ or - with space
            .replace(/\b\w/g, (l) => l.toUpperCase()); // capitalize first letter
    };

    const [acceptedObject, setAcceptedObject] = useState({});
    console.log('acceptedObject', acceptedObject)

    const handleOnRejectedClick = (key, image) => {
        const imageURL = image instanceof File ? URL.createObjectURL(image) : image;

        setRejectedObject((prev) => {
            const newObj = { ...prev };

            if (newObj[key]) {
                delete newObj[key]; // remove rejected image
            } else {
                newObj[key] = imageURL; // add rejected image
            }

            // Save to localStorage
            localStorage.setItem('rejectedImages', JSON.stringify(newObj));

            // Update reason text
            const reasonLines = Object.entries(newObj).map(([k, url]) => {
                const label = formatLabel(k);
                return `🚫 ${label}: ${url}`;
            });

            const reasonText = reasonLines.length > 0
                ? `Hey! These are issues we found, please rectify:\n\n${reasonLines.join('\n')} for it`
                : '';

            setFormData((prevFormData) => ({
                ...prevFormData,
                ReasonOfRejection: reasonText,
            }));

            return newObj;
        });

        setAcceptedObject((prev) => {
            const newObj = { ...prev };
            if (newObj[key]) {
                delete newObj[key];
                localStorage.setItem('acceptedImages', JSON.stringify(newObj));
            }
            return newObj;
        });
    };


    const handleOnAcceptedClick = (key, image) => {
        const imageURL = image instanceof File ? URL.createObjectURL(image) : image;

        setAcceptedObject((prev) => {
            const newObj = { ...prev };

            if (newObj[key]) {
                delete newObj[key]; // unmark as accepted
            } else {
                newObj[key] = imageURL; // mark as accepted
            }

            // Save to localStorage
            localStorage.setItem('acceptedImages', JSON.stringify(newObj));

            return newObj;
        });

        setRejectedObject((prev) => {
            const newObj = { ...prev };
            if (newObj[key]) {
                delete newObj[key];
                localStorage.setItem('rejectedImages', JSON.stringify(newObj));
            }
            return newObj;
        });
    };





    const toggleVehicleImage = (vehicleNo) => {
        setIsOpenImage((prev) => ({
            ...prev,
            [vehicleNo]: !prev[vehicleNo],
        }));
    };

    const handleInputChange = (e) => {
        if (e.target.name === 'state') {
            loadCities(e.target.value);
        }

        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleAddVehicleNo = () => {
        const newVehicle = tempVehicleNo.trim();
        if (newVehicle && !formData.vehicleNo.includes(newVehicle)) {
            setStoredVehicleNos([...storedVehicleNos, newVehicle]);
            setFormData((prevData) => ({ ...prevData, vehicleNo: [...(prevData.vehicleNo || []), newVehicle] }));
            setTempVehicleNo(""); // clear input
        }
    };

    const MAX_SIZE_MB = 1;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

    const handleImageChange = async (key, file) => {
        if (!file) return;

        try {
            const compressedFile = await compressFile(file);
            console.log('compressedFile.size', compressedFile.size)
            if (compressedFile.size > MAX_SIZE_BYTES) {
                alert('Image should be less than 1 MB.');
                return;
            }
            setNewImages((prev) => ({
                ...prev,
                [key]: compressedFile,
            }));
            setImages((prev) => ({
                ...prev,
                [key]: compressedFile,
            }));
        } catch (error) {
            console.error("Image compression error:", error);
            alert("Failed to process image.");
        }
    };


    const compressFile = (file) => {
        return new Promise((resolve, reject) => {
            // Allow image compression only for image types
            if (file.type.startsWith("image/")) {
                const reader = new FileReader();

                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement("canvas");

                        const scale = Math.min(800 / img.width, 800 / img.height, 1);
                        canvas.width = img.width * scale;
                        canvas.height = img.height * scale;

                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                        canvas.toBlob(
                            (blob) => {
                                if (blob) {
                                    const compressedFile = new File([blob], file.name, { type: file.type });
                                    if (compressedFile.size <= 1024 * 1024) {
                                        resolve(compressedFile);
                                    } else {
                                        reject(new Error("Image should be less than 1MB even after compression."));
                                    }
                                } else {
                                    reject(new Error("Compression failed"));
                                }
                            },
                            file.type,
                            0.7
                        );
                    };
                    img.onerror = reject;
                    img.src = event.target.result;
                };

                reader.onerror = reject;
                reader.readAsDataURL(file);
            } else {
                // For non-image files, check file size only
                if (file.size <= 1024 * 1024) {
                    resolve(file);
                } else {
                    reject(new Error("Document should be less than 1MB."));
                }
            }
        });
    };



    const handleAddImageField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeys((prev) => [...prev, newKey]);
    };

    const handleAddVehicleImageField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeysForVehicle((prev) => [...prev, newKey]);
    }

    const handleAddImageCompanyField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeysCompany((prev) => [...prev, newKey]);
    };

    const [selectedVehicleNo, setSelectedVehicleNo] = useState(null);


    const [countOfImages, setCountOfImages] = useState(0);
    const [openDeletionModal, setOpenDeletionModal] = useState(false);
    const [deletionImage, setDeletionInmage] = useState(null);

    const deleteImage = async (key) => {
        setImages((prev) => {
            const newImages = { ...prev };
            delete newImages[key];
            return newImages;
        })
    };

    const handleSubmit = async (action, e, vehicleNo) => {
        e?.preventDefault();
        setIsSubmitting(true);
        console.log('heodasjf')


        try {
            const formDataObj = new FormData();

            // Append form fields where the **key includes** the vehicle number
            for (const key in formData) {
                if (
                    formData[key] !== undefined &&
                    formData[key] !== null &&
                    formData[key] !== "" &&
                    key.includes(selectedVehicleNo)
                ) {
                    formDataObj.append(key, formData[key]);
                }
            }

            // Always include vehicle number explicitly
            formDataObj.append('vehicleNo', selectedVehicleNo);

            // Append image files where the **key includes** the vehicle number
            console.log('images', images)
            for (const key in images) {
                const file = images[key];
                if (file instanceof File && key.includes(selectedVehicleNo)) {
                    console.log('image to be appendiede', key)
                    formDataObj.append(`images[${key}]`, file, file.name);
                }
            }

            // Debug log
            for (let pair of formDataObj.entries()) {
                console.log(`${pair[0]}:`, pair[1]);
            }

            console.log('heodasjf')

            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/updateStatusOfIncomingVendor/${state.id}/${selectedVehicleNo}/${action}/${(formData.chooseFromSelectedService == null || formData.chooseFromSelectedService == "") ? "notchoosen" : formData.chooseFromSelectedService}/${(formData.ReasonOfRejection == null || formData.ReasonOfRejection == "") ? null : formData.ReasonOfRejection}/${(formData.subType)}`,
                formDataObj,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );

            if (response.data) {
                // 1. Close this vehicle box
                setIsOpenImage(prev => ({ ...prev, [vehicleNo]: false }));
                setFormData((prev) => ({
                    ...prev,
                    ReasonOfRejection: "",
                    subType:null
                }))
                setRejectedObject({})
                setSelectedVehicleNo(null)
                setIsOpenImage({})
                // 2. Track submitted vehicle
                setSubmittedVehicles(prev => {
                    const updated = [...prev, vehicleNo];

                    // 3. If all vehicles submitted, navigate
                    if (updated.length === formData.vehicleNo.length) {
                        localStorage.removeItem("acceptedObject");
                        localStorage.removeItem("rejectedObject");
                        setTimeout(() => navigate('/NewVendorApproved'), 500); // small delay optional
                    }

                    return updated;
                });
            }
        } catch (error) {
            console.error("Error during form submission:", error);
            const errorMessage = error.response?.data?.message || "An error occurred";
            if (errorMessage === "jwt expired") {
                setTimeout(() => window.location.href = "/", 2000);
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubmitKYC = async (action, e, vehicleNo) => {
        e?.preventDefault();
        setIsSubmitting(true);

        try {
            const formDataObj = new FormData();
            for (const key in formData) {
                if (formData[key] !== undefined && formData[key] !== null && formData[key] !== "") {
                    if (key === "vendorName" || key === "vendorPhone" || key == 'fatherName' || key == "address" || key == 'state' || key == 'city' || key == "companyName") {
                        formDataObj.append(key, formData[key]);
                    }
                }
            }
            for (const key in newImages) {
                const file = images[key];
                if (file instanceof File) {
                    formDataObj.append(`images[${key}]`, file, file.name);
                }
            }
            console.log('heloow')

            for (let pair of formDataObj.entries()) {
                console.log(`${pair[0]}:`, pair[1]);
            }
            console.log('heloow')

            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/updateStatusOfIncomingKYC/${state.id}/${selectedVehicleNo}/${action}/${(formData.ReasonOfRejection == null || formData.ReasonOfRejection == "") ? null : formData.ReasonOfRejection}`,
                formDataObj,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );

            if (response.data) {
                // 1. Close this vehicle box
                setIsOpenImage(prev => ({ ...prev, [vehicleNo]: false }));
                setFormData((prev) => ({
                    ...prev,
                    ReasonOfRejection: ""
                }))
                setRejectedObject({})
                setAcceptedObject({})
                setSelectedVehicleNo(null)
                setNewImages({})
                await getDataById(currentVendorId);
                if (formData.vehicleNo.length > 0) setNextPage(3);
                else navigate('/NewVendorApproved');

            }
        } catch (error) {
            console.error("Error during form submission:", error);
            const errorMessage = error.response?.data?.message || "An error occurred";
            if (errorMessage === "jwt expired") {
                setTimeout(() => window.location.href = "/", 2000);
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const [showKycModal, setShowKycModal] = useState(false);
    const [showVehiclesModal, setShowVehiclesModal] = useState(false);

    const commonRequiredImages = [
        "Photo of the Owner",
        "Adhar Card Front",
        "Adhar Card Back",
        "Pan Card",
        "Cancelled cheque"
    ];

    const nonIndividualRequiredImages = [
        "MOA",
        "Partnership Deed or Company Registration Certificate"
    ];
    const partnerShipRequiredImages = [
        "Partnership Deed or Company Registration Certificate"
    ];

    const requiredImages = [
        ...commonRequiredImages,
        ...(formData.typeOfAgreement === 'non-individual' ? nonIndividualRequiredImages : []),
        ...(formData.typeOfAgreement === "Partnership-Firm" ? partnerShipRequiredImages : [])
    ];

    const allImagesReviewed = requiredImages.every((key) =>
        images[key] && (acceptedObject[key] || rejectedObject[key])
    );






    // On state change, save to localStorage
    useEffect(() => {
        localStorage.setItem('acceptedObject', JSON.stringify(acceptedObject));
    }, [acceptedObject]);

    useEffect(() => {
        localStorage.setItem('rejectedObject', JSON.stringify(rejectedObject));
    }, [rejectedObject]);

    // On component mount, restore from localStorage
    useEffect(() => {
        const savedAccepted = JSON.parse(localStorage.getItem('acceptedObject') || '{}');
        const savedRejected = JSON.parse(localStorage.getItem('rejectedObject') || '{}');
        setAcceptedObject(savedAccepted);
        setRejectedObject(savedRejected);
    }, []);





    return (
        <div className="bg-white h-full">

            <div className="flex lg:flex-row flex-col justify-center gap-[30px]">
                <div>
                    <div className="items-end justify-end pt-3">
                        <div
                            className={`flex items-center py-[5px] rounded-full pr-[6px] pl-[16px] cursor-pointer bg-[#21A6E9] hover:bg-red-300`}
                        >
                            <button className="flex items-center gap-2 font-satoshi font-[400] text-[18px] leading-[33.6px] text-white pr-5">
                                <img
                                    src="https://static.vecteezy.com/system/resources/previews/019/879/209/non_2x/download-button-on-transparent-background-free-png.png"
                                    alt="icon"
                                    className="h-[40px] w-[40px] object-contain"
                                />
                                Generate Excel
                            </button>
                        </div>
                    </div>

                    <div className=" flex items-center justify-center gap-4 pt-1 ">

                    </div>



                    {/* {formData.typeOfAgreement === "non-individual" && ( */}
                    <div>
                        {formData.currentStatus != 1 && (<div>
                            {(formData.ReasonOfRejectionKYC !== "" && formData.ReasonOfRejectionKYC !== null) && (
                                <div onClick={() => setShowKycModal(true)} style={{ border: '2px solid red' }} className="absolute z-[999] top-4 right-2 border-2 bg-white border-red-600 text-red-600 rounded-full px-4 py-2 flex items-center justify-center text-xs hover:bg-red-800 cursor-pointer">
                                    View Rejected Reason KYC
                                </div>)}

                            {showKycModal && (
                                <div className="fixed inset-0 z-[1000] bg-black/60 bg-opacity-40 backdrop-blur-sm flex items-center justify-center">
                                    <div className="bg-white rounded-2xl shadow-xl w-[90%] max-w-lg p-6 relative">
                                        <button
                                            className="absolute top-2 right-3 text-gray-500 hover:text-red-500 text-lg"
                                            onClick={() => setShowKycModal(false)}
                                        >
                                            ✕
                                        </button>
                                        <h2 className="text-xl text-center font-semibold text-red-600 mb-4">
                                            KYC Rejection Reason
                                        </h2>

                                        <div className="space-y-4 max-h-[70vh] overflow-y-auto text-sm text-gray-800">
                                            {formData.ReasonOfRejectionKYC?.split("•")
                                                .map((item, index) => item.trim())
                                                .filter(Boolean)
                                                .map((entry, index) => {
                                                    const splitIndex = entry.indexOf(":");
                                                    const hasKeyValue = splitIndex !== -1;

                                                    if (hasKeyValue) {
                                                        const key = entry.slice(0, splitIndex).trim();
                                                        const value = entry.slice(splitIndex + 1).trim();

                                                        return (
                                                            <div key={index} className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                                                                <div className="font-semibold text-gray-600">{key}</div>
                                                                <div className="text-gray-700 mt-1">{value}</div>
                                                            </div>
                                                        );
                                                    } else {
                                                        return (
                                                            <div key={index}>
                                                                <hr className="my-2 border-gray-300" />
                                                                <div className="text-gray-700">{entry}</div>
                                                            </div>
                                                        );
                                                    }
                                                })}
                                        </div>
                                    </div>
                                </div>
                            )}


                            {nextPage === 1 && (
                                <form className=" font-satoshi max-w-xl mx-auto p-4 bg-white rounded-md space-y-4 mb-5 ">



                                    <div className="flex min-w-[50vw] md:flex-row items-center justify-around gap-1 p-2 mt-2">
                                        <h2 className="text-xl font-semibold text-center my-2">KYC INFORMATION</h2>

                                    </div>
                                    {["vehicleNo", "vendorName", "companyName", "fatherName", "vendorPhone", "state", "city", "address"].filter(
                                        (field) =>
                                            !(formData.typeOfAgreement === "individual" && field === "companyName") &&
                                            !((formData.typeOfAgreement === "non-individual" || formData.typeOfAgreement == 'Properiter-Firm' || formData.typeOfAgreement === "Partnership-Firm") && field === "fatherName")
                                    ).map((field) => (
                                        <div key={field} className="flex flex-col">
                                            <label
                                                htmlFor={field}
                                                className="mb-1 text-sm text-gray-700 capitalize font-semibold text-[12px]"
                                            >
                                                {field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                            </label>

                                            {/* Handle textarea for residence_address */}
                                            {field === "address" ? (
                                                <textarea
                                                    id={field}
                                                    name={field}
                                                    value={formData[field]}
                                                    placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                    onChange={handleInputChange}
                                                    className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                    rows={4}

                                                />
                                            ) : field === "vehicleNo" ? (
                                                <div className="flex flex-col gap-2">
                                                    <div className="flex gap-2">
                                                        <input
                                                            id={field}
                                                            name={field}
                                                            value={formData.vehicleNo}
                                                            placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                            // onChange={(e)=> setFormData.vehicleNo}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    vehicleNo: e.target.value,
                                                                }))
                                                            }
                                                            className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"

                                                        />

                                                    </div>

                                                    {/* Display all stored vehicle numbers */}
                                                    {/* {formData.vehicleNo.map((vehicleNo, index) => (
                                                        <div
                                                            key={index}
                                                            style={{ background: '#e7c7c7' }}
                                                            className="relative flex text-black max-w-[45vw] rounded-[7px] px-4 py-2 mb-2 sm:text-[12px] md:text-[15px]"
                                                        >
                                                            {vehicleNo}
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    const updatedVehicleNos = [...formData.vehicleNo];
                                                                    updatedVehicleNos.splice(index, 1);
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        vehicleNo: updatedVehicleNos,
                                                                    }));
                                                                }}
                                                                className="absolute top-1 right-2 text-red-600 font-bold hover:text-red-800"
                                                                title="Remove"
                                                            >
                                                                ✕
                                                            </button>
                                                        </div>
                                                    ))} */}

                                                </div>
                                            ) : (
                                                // Handle regular input
                                                <input
                                                    id={field}
                                                    name={field}
                                                    value={formData[field]}
                                                    placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}`}

                                                    onChange={(e) => {
                                                        let value = e.target.value;

                                                        // Capitalize owner_name and father_name
                                                        if (["vendorName", "fatherName"].includes(field)) {
                                                            value = value.toUpperCase();
                                                        }

                                                        // Restrict mobile_no to 10 digits only
                                                        if (field === "vendorPhone") {
                                                            value = value.replace(/\D/g, "").slice(0, 10);
                                                        }

                                                        handleInputChange({ target: { name: field, value } });
                                                    }}
                                                    className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                    style={{ padding: "20px" }}

                                                />
                                            )}
                                        </div>
                                    ))}



                                    <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                        <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">

                                            <button
                                                onClick={() => setNextPage(2)}
                                                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                                bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                            >
                                                Continue
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                            </button>

                                            <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                        </div>
                                    </div>




                                </form>
                            )}

                            {nextPage === 2 && (
                                // <form className=" font-satoshi  max-w-xl mx-auto p-4 bg-white rounded-md space-y-4 mb-5 md:min-w-[400px]">
                                <form className="font-satoshi max-w-xl mx-auto p-4 bg-white rounded-md space-y-4 mb-5 md:min-w-[400px]">

                                    <div className="flex  md:flex-row items-center justify-between gap-2 p-2">
                                        <h2 className="text-xl font-semibold text-center my-2">VIEW KYC IMAGES</h2>

                                    </div>

                                    <div className="overflow-auto grid grid-cols-2 lg:grid-cols-2 gap-[0.7rem]">
                                        {/* {imageKeys.filter((key) => !key.includes(vehicleNo)).map((key) => ( */}
                                        {imageKeys
                                            .filter((key) => !/-?[A-Z]{2}\d{2}[A-Z]{2}\d{4}$/.test(key))
                                            .map((key) => (
                                                <div key={key}>

                                                    <div
                                                        className={`flex flex-col relative p-[0.2rem] rounded-xl border-2 border-dotted 
        ${rejectedObject[key] ? 'border-red-600 bg-white' : acceptedObject[key] ? 'border-green-800' : 'border-gray-600'}`}
                                                    // style={
                                                    //     rejectedObject[key] && !acceptedObject[key]
                                                    //         ? { boxShadow: '4px -4px 20px 7px rgba(240, 13, 13, 0.3)' }
                                                    //         : acceptedObject[key] && !rejectedObject[key]
                                                    //             ? { boxShadow: '4px -4px 20px 7px rgba(13, 240, 13, 0.3)' }
                                                    //             : {}
                                                    // }
                                                    >


                                                        {images[key] ? (
                                                            <>
                                                                <div className="relative w-full h-[6rem] rounded-[10%] ">
                                                                    {(() => {
                                                                        const fileUrl = images[key] instanceof File ? URL.createObjectURL(images[key]) : images[key];
                                                                        console.log('fileUrl', fileUrl)
                                                                        const isPdf = fileUrl.toLowerCase().endsWith('.pdf');
                                                                        console.log('isPdf', isPdf)

                                                                        return isPdf ? (
                                                                            <div onClick={() => setModalImage(fileUrl)} className="w-full h-[6rem] border border-gray-300 rounded-xl flex items-center justify-center cursor-pointer bg-gray-100 hover:bg-gray-200">
                                                                                <span className="text-sm text-gray-700">Click to open PDF</span>
                                                                            </div>
                                                                        ) : (
                                                                            <img
                                                                                src={fileUrl}
                                                                                alt={key}
                                                                                onClick={() => setModalImage(fileUrl)}
                                                                                className="w-full h-[6rem] rounded-xl object-cover cursor-pointer"
                                                                            />
                                                                        );
                                                                    })()}


                                                                    <button
                                                                        type="button"

                                                                        className="absolute top-0 right-0 bg-white text-red-600 rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                                                                        title="Remove Image"
                                                                    >
                                                                        <Trash2 size={16} onClick={() => {
                                                                            setDeletionInmage(key)
                                                                            setOpenDeletionModal(true)
                                                                        }} />
                                                                    </button>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center mt-[2rem]">
                                                                <button
                                                                    type="button"
                                                                    style={{ background: 'rgb(140 140 140)' }}
                                                                    className="relative center-button text-white p-2 rounded-full shadow-lg hover:bg-black focus:outline-none"
                                                                    onClick={() => document.getElementById(`hiddenFileInput-${key}`).click()}
                                                                >
                                                                    <AddIcon />
                                                                </button>
                                                                <input
                                                                    type="file"
                                                                    id={`hiddenFileInput-${key}`}
                                                                    accept="image/*"
                                                                    onChange={(e) => handleImageChange(key, e.target.files[0])}
                                                                    className=" form-control text-xs hidden opacity-0"
                                                                />
                                                            </div>

                                                        )}
                                                    </div>
                                                    <label className="mb-1 text-sm grid grid-cols-1 text-[12px] text-gray-700 mt-[0.5rem] text-center justify-center items-center gap-2 md:grid-cols-1">
                                                        {key.charAt(0).toUpperCase() + key.slice(1)}

                                                        <div className="flex  flex-col gap-2 items-center justify-center md:flex-row">
                                                            <div
                                                                className={`flex items-center justify-center text-center gap-1 cursor-pointer `}
                                                                style={
                                                                    acceptedObject[key]
                                                                        ? {
                                                                            border: '2px solid rgb(23, 228, 20)', // Tailwind 'red-800' hex = #991b1b
                                                                            padding: '0.1rem 0.5rem',    // py-2 px-6
                                                                            borderRadius: '0.75rem',     // rounded-xl = 12px = 0.75rem
                                                                            color: '#991b1b',
                                                                        }
                                                                        : { color: '#ef4444' } // Tailwind 'red-500'
                                                                }
                                                                title="Mark as Accepted"
                                                                onClick={() => handleOnAcceptedClick(key, images[key])}
                                                            >
                                                                <CheckCircle className={`w-5 h-5 ${acceptedObject[key] ? 'text-green-800' : 'text-green-500'}`} />
                                                                <span className={`text-xs text-center ${acceptedObject[key] ? 'text-green-800 font-semibold' : 'text-green-500'}`}>
                                                                    Approved
                                                                </span>
                                                            </div>

                                                            <div
                                                                className={`flex  items-center justify-center text-center gap-1 cursor-pointer `}
                                                                style={
                                                                    rejectedObject[key]
                                                                        ? {
                                                                            border: '2px solid #991b1b', // Tailwind 'red-800' hex = #991b1b
                                                                            padding: '0.1rem 0.5rem',     // py-2 px-6
                                                                            borderRadius: '0.75rem',     // rounded-xl = 12px = 0.75rem
                                                                            color: '#991b1b',
                                                                        }
                                                                        : { color: '#ef4444' } // Tailwind 'red-500'
                                                                }
                                                                title="Mark as Rejected"
                                                                onClick={() => handleOnRejectedClick(key, images[key])}
                                                            >
                                                                <XCircle className={`w-5 h-5 ${rejectedObject[key] ? 'text-red-800' : 'text-red-500'}`} />
                                                                <span className={`text-xs text-center ${rejectedObject[key] ? 'text-red-800 font-semibold' : 'text-red-500'}`}>
                                                                    Rejected
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </label>

                                                </div>
                                            ))}
                                    </div>


                                    {modalImage && (
                                        <div>


                                            <div
                                                style={{ background: 'linear-gradient(45deg, black, transparent)' }}
                                                className="fixed inset-0 flex flex-col items-center justify-center z-[1000] md:flex-row md:p-4 md:gap-4"
                                            >
                                                <form className=" max-h-[90vh] w-[90vw] overflow-x-auto font-satoshi max-w-xl mx-auto p-4 bg-white rounded-md space-y-4 mb-5 md:min-w-[50vw] ">

                                                    {["vehicleNo", "vendorName", "companyName", "fatherName", "vendorPhone", "state", "city", "address"].filter(
                                                        (field) =>
                                                            !(formData.typeOfAgreement === "individual" && field === "companyName") &&
                                                            !(formData.typeOfAgreement === "non-individual" && field === "fatherName")
                                                    ).map((field) => (
                                                        <div key={field} className="flex flex-col">
                                                            <label
                                                                htmlFor={field}
                                                                className="mb-1 text-sm text-gray-700 capitalize font-semibold text-[12px]"
                                                            >
                                                                {field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                                            </label>

                                                            {/* Handle textarea for residence_address */}
                                                            {field === "address" ? (
                                                                <textarea
                                                                    id={field}
                                                                    name={field}
                                                                    value={formData[field]}
                                                                    placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                                    onChange={handleInputChange}
                                                                    className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                                    rows={4}

                                                                />
                                                            ) : field === "vehicleNo" ? (
                                                                <div className="flex flex-col gap-2">
                                                                    <div className="flex gap-2">
                                                                        <input
                                                                            id={field}
                                                                            name={field}
                                                                            value={formData.vehicleNo}
                                                                            placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                                            // onChange={(e)=> setFormData.vehicleNo}
                                                                            onChange={(e) =>
                                                                                setFormData((prev) => ({
                                                                                    ...prev,
                                                                                    vehicleNo: e.target.value,
                                                                                }))
                                                                            }
                                                                            className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"

                                                                        />

                                                                    </div>

                                                                    {/* Display all stored vehicle numbers */}
                                                                    {/* {formData.vehicleNo.map((vehicleNo, index) => (
                                                        <div
                                                            key={index}
                                                            style={{ background: '#e7c7c7' }}
                                                            className="relative flex text-black max-w-[45vw] rounded-[7px] px-4 py-2 mb-2 sm:text-[12px] md:text-[15px]"
                                                        >
                                                            {vehicleNo}
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    const updatedVehicleNos = [...formData.vehicleNo];
                                                                    updatedVehicleNos.splice(index, 1);
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        vehicleNo: updatedVehicleNos,
                                                                    }));
                                                                }}
                                                                className="absolute top-1 right-2 text-red-600 font-bold hover:text-red-800"
                                                                title="Remove"
                                                            >
                                                                ✕
                                                            </button>
                                                        </div>
                                                    ))} */}

                                                                </div>
                                                            ) : (
                                                                // Handle regular input
                                                                <input
                                                                    id={field}
                                                                    name={field}
                                                                    value={formData[field]}
                                                                    placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}`}

                                                                    onChange={(e) => {
                                                                        let value = e.target.value;

                                                                        // Capitalize owner_name and father_name
                                                                        if (["vendorName", "fatherName"].includes(field)) {
                                                                            value = value.toUpperCase();
                                                                        }

                                                                        // Restrict mobile_no to 10 digits only
                                                                        if (field === "vendorPhone") {
                                                                            value = value.replace(/\D/g, "").slice(0, 10);
                                                                        }

                                                                        handleInputChange({ target: { name: field, value } });
                                                                    }}
                                                                    className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                                    style={{ padding: "20px" }}

                                                                />
                                                            )}
                                                        </div>
                                                    ))}








                                                </form>
                                                <div
                                                    onClick={(e) => e.stopPropagation()}
                                                    className="bg-white p-4 rounded-lg shadow-lg max-w-[95%] max-h-[95%] overflow-hidden relative"
                                                >
                                                    {modalImage.toLowerCase().endsWith('.pdf') ? (
                                                        <iframe
                                                            src={modalImage}
                                                            title="PDF Preview"
                                                            className="min-w-full min-h-[90vh] rounded-md object-cover"

                                                        />
                                                    ) : (
                                                        <img
                                                            src={modalImage}
                                                            alt="Preview"
                                                            className="max-w-full max-h-[90vh] rounded-md object-cover"
                                                        />
                                                    )}

                                                    <button
                                                        onClick={() => setModalImage(null)}
                                                        className="absolute top-10 right-10 text-1xl text-gray-600 hover:text-black focus:outline-none"
                                                        title="Close"
                                                    >
                                                        ❌
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                    )}






                                    <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                        <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                            <button
                                                onClick={() => setNextPage(1)}
                                                className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                            >
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px] scale-x-[-1]" />
                                                Back
                                            </button>
                                            <button
                                                // onClick={() => setNextPage(3)}
                                                type="button"
                                                disabled={!allImagesReviewed}
                                                onClick={() => {
                                                    setIsModalOpen(true); // Open modal
                                                    setIsOpenFor('KYC')
                                                }}
                                                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                               ${allImagesReviewed ? 'bg-[#21A6E9] hover:bg-[#1e94d6]' : 'bg-gray-400 cursor-not-allowed'}`}
                                            >
                                                Continue
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                            </button>

                                            <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>)}

                        {nextPage === 3 && (
                            // <form className=" font-satoshi max-w-xl mx-auto p-4 bg-white rounded-md space-y-4 mb-5 ">

                            <form className="font-satoshi max-w-xl mx-auto p-4 bg-white rounded-md space-y-4 mb-5 md:min-w-[400px]">
                                {(formData.allReasonsOfRejection !== "" && formData.allReasonsOfRejection !== null) && (
                                    <div onClick={() => setShowVehiclesModal(true)} style={{ border: '2px solid red' }} className="absolute z-[999] top-4 right-2 border-2 bg-white border-red-600 text-red-600 rounded-full px-4 py-2 flex items-center justify-center text-xs hover:bg-red-800 cursor-pointer">
                                        View Rejected Reason Vehicles
                                    </div>)}

                                {showVehiclesModal && (
                                    <div className="fixed inset-0 z-[1000] bg-black/60 bg-opacity-40 backdrop-blur-sm flex items-center justify-center">
                                        <div className="bg-white rounded-2xl shadow-xl w-[90%] max-w-lg p-6 relative">
                                            <button
                                                className="absolute top-2 right-3 text-gray-500 hover:text-red-500 text-lg"
                                                onClick={() => setShowVehiclesModal(false)}
                                            >
                                                ✕
                                            </button>
                                            <h2 className="text-xl text-center font-semibold text-red-600 mb-4">
                                                Vehicles Rejection Reason
                                            </h2>

                                            <div className="space-y-4 max-h-[70vh] overflow-y-auto text-sm text-gray-800">
                                                {formData.allReasonsOfRejection?.split("•")
                                                    .map((item, index) => item.trim())
                                                    .filter(Boolean)
                                                    .map((entry, index) => {
                                                        const splitIndex = entry.indexOf(":");
                                                        const hasKeyValue = splitIndex !== -1;

                                                        if (hasKeyValue) {
                                                            const key = entry.slice(0, splitIndex).trim();
                                                            const value = entry.slice(splitIndex + 1).trim();

                                                            return (
                                                                <div key={index} className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                                                                    <div className="font-semibold text-gray-600">{key}</div>
                                                                    <div className="text-gray-700 mt-1">{value}</div>
                                                                </div>
                                                            );
                                                        } else {
                                                            return (
                                                                <div key={index}>
                                                                    <hr className="my-2 border-gray-300" />
                                                                    <div className="text-gray-700">{entry}</div>
                                                                </div>
                                                            );
                                                        }
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                )}


                                <div className="flex  md:flex-row items-center justify-between gap-2 p-2">
                                    <h2 className="text-xl font-semibold text-center my-2">VIEW VEHICLES IMAGES</h2>

                                </div>

                                <div className="w-full">
                                    {formData.vehicleNo.map((vehicleNo) => (
                                        <div key={vehicleNo} className="mb-6">
                                            <div
                                                {...(isOpenImage[vehicleNo] && {
                                                })}
                                            >
                                                <div onClick={() => toggleVehicleImage(vehicleNo)} className="flex items-center justify-between px-3 py-1 mt-1 rounded">
                                                    <div className="text-sm font-semibold text-black">
                                                        {vehicleNo}
                                                    </div>
                                                    {isOpenImage[vehicleNo] ? (
                                                        <ChevronDown
                                                            className="text-black h-6 p-1 bg-gray-200 rounded-full"
                                                        />
                                                    ) : (
                                                        <ChevronUp
                                                            className="text-black h-6 p-1 bg-gray-200 rounded-full"
                                                        />
                                                    )}
                                                </div>
                                                {isOpenImage[vehicleNo] && (
                                                    <div className="mt-2">
                                                        <input
                                                            name={`driverName-${vehicleNo}`}
                                                            value={formData[`driverName-${vehicleNo}`] || ""}
                                                            placeholder="Enter Driver Name"
                                                            onChange={(e) => {
                                                                const { name, value } = e.target;
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    [name]: value,
                                                                }));
                                                            }}
                                                            style={{ border: '1px solid' }}
                                                            className=" border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-[95%] m-2"
                                                        />

                                                        <input
                                                            name={`driverNumber-${vehicleNo}`}
                                                            value={formData[`driverNumber-${vehicleNo}`] || ""}
                                                            placeholder="Enter Driver Number"
                                                            onChange={(e) => {
                                                                const { name, value } = e.target;
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    [name]: value,
                                                                }));

                                                            }}
                                                            style={{ border: '1px solid' }}
                                                            className=" border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-[95%] m-2"
                                                        />
                                                        <input
                                                            name={`driverDLNos-${vehicleNo}`}
                                                            value={formData[`driverDLNos-${vehicleNo}`] || ""}
                                                            placeholder="Enter DL No"
                                                            onChange={(e) => {
                                                                const { name, value } = e.target;
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    [name]: value,
                                                                }));
                                                            }}
                                                            style={{ border: '1px solid' }}
                                                            className=" border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-[95%] m-2"
                                                        />
                                                        <input
                                                            type='date'
                                                            name={`driverDOBs-${vehicleNo}`}
                                                            value={formData[`driverDOBs-${vehicleNo}`] || ""}
                                                            max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split("T")[0]} // max date = today - 18 years
                                                            placeholder="Enter Driver DOB"
                                                            onChange={(e) => {
                                                                const name = e.target.name;
                                                                const value = e.target.value.toUpperCase();
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    [name]: value,
                                                                }));
                                                            }}
                                                            className="border border-[#DEDEE8] bg-[#F6F6F6] rounded pl-3 py-2 w-[90%] m-2"
                                                        />
                                                        <div style={{ background: 'linear-gradient(#ffffff, #d5d7d5)' }} className="relative flex flex-col mt-3 p-2 rounded-xl min-h-[300px]">
                                                            <div className="grid grid-cols-2 gap-4">
                                                                {imageKeys.filter((key) => key.includes(vehicleNo)).map((key) => (
                                                                    <div>
                                                                        <div key={key} className={`flex flex-col relative p-[0.2rem] rounded-xl border-dotted border-2 ${rejectedObject[key] ? 'border-red-600 bg-white' : 'border-gray-600'}`}
                                                                            style={rejectedObject[key] ? { boxShadow: '4px -4px 20px 7px rgba(240, 13, 13, 0.3)' } : {}}>

                                                                            {images[key] ? (
                                                                                <div className="relative w-full h-[6rem]  rounded-md">
                                                                                    {(() => {
                                                                                        const fileUrl = images[key] instanceof File ? URL.createObjectURL(images[key]) : images[key];
                                                                                        console.log('fileUrl', fileUrl)
                                                                                        const isPdf = fileUrl.toLowerCase().endsWith('.pdf');
                                                                                        console.log('isPdf', isPdf)

                                                                                        return isPdf ? (
                                                                                            <div onClick={() => setModalImage(fileUrl)} className="w-full h-[6rem] border border-gray-300 rounded-xl flex items-center justify-center cursor-pointer bg-gray-100 hover:bg-gray-200">
                                                                                                <span className="text-sm text-gray-700">Click to open PDF</span>
                                                                                            </div>
                                                                                        ) : (
                                                                                            <img
                                                                                                src={fileUrl}
                                                                                                alt={key}
                                                                                                onClick={() => setModalImage(fileUrl)}
                                                                                                className="w-full h-[6rem] rounded-xl object-cover cursor-pointer"
                                                                                            />
                                                                                        );
                                                                                    })()}

                                                                                    <button
                                                                                        type="button"

                                                                                        className="absolute top-0 right-0 bg-white text-red-600 rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                                                                                        title="Remove Image"
                                                                                    >
                                                                                        <Trash2 size={16} onClick={() => {
                                                                                            setDeletionInmage(key)
                                                                                            setOpenDeletionModal(true)
                                                                                        }} />
                                                                                    </button>
                                                                                </div>
                                                                            ) : (
                                                                                <div className="flex flex-col items-center justify-center mt-[2rem]">
                                                                                    <button
                                                                                        type="button"
                                                                                        style={{ background: 'rgb(140 140 140)' }}
                                                                                        className="relative center-button text-white p-2 rounded-full shadow-lg hover:bg-black focus:outline-none"
                                                                                        onClick={() => document.getElementById(`hiddenFileInput-${key}`).click()}
                                                                                    >
                                                                                        <AddIcon />
                                                                                    </button>
                                                                                    {/* <input
                                                                                        type="file"
                                                                                        id={`hiddenFileInput-${key}`}
                                                                                        accept="image/*"
                                                                                        onChange={(e) => handleImageChange(key, e.target.files[0])}
                                                                                        className=" form-control text-xs hidden opacity-0"
                                                                                    /> */}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <label className="mb-1 text-sm grid grid-cols-1 text-[12px] text-gray-700 mt-[0.5rem] text-center justify-center items-center gap-2 md:grid-cols-1">
                                                                            {key}

                                                                            <div className="flex  flex-col gap-2 items-center justify-center md:flex-row">
                                                                                <div
                                                                                    className={`flex items-center justify-center text-center gap-1 cursor-pointer `}
                                                                                    style={
                                                                                        acceptedObject[key]
                                                                                            ? {
                                                                                                border: '2px solid rgb(23, 228, 20)', // Tailwind 'red-800' hex = #991b1b
                                                                                                padding: '0.1rem 0.5rem',    // py-2 px-6
                                                                                                borderRadius: '0.75rem',     // rounded-xl = 12px = 0.75rem
                                                                                                color: '#991b1b',
                                                                                            }
                                                                                            : { color: '#ef4444' } // Tailwind 'red-500'
                                                                                    }
                                                                                    title="Mark as Accepted"
                                                                                    onClick={() => handleOnAcceptedClick(key, images[key])}
                                                                                >
                                                                                    <CheckCircle className={`w-5 h-5 ${acceptedObject[key] ? 'text-green-800' : 'text-green-500'}`} />
                                                                                    <span className={`text-xs text-center ${acceptedObject[key] ? 'text-green-800 font-semibold' : 'text-green-500'}`}>
                                                                                        Approved
                                                                                    </span>
                                                                                </div>

                                                                                <div
                                                                                    className={`flex  items-center justify-center text-center gap-1 cursor-pointer `}
                                                                                    style={
                                                                                        rejectedObject[key]
                                                                                            ? {
                                                                                                border: '2px solid #991b1b', // Tailwind 'red-800' hex = #991b1b
                                                                                                padding: '0.1rem 0.5rem',     // py-2 px-6
                                                                                                borderRadius: '0.75rem',     // rounded-xl = 12px = 0.75rem
                                                                                                color: '#991b1b',
                                                                                            }
                                                                                            : { color: '#ef4444' } // Tailwind 'red-500'
                                                                                    }
                                                                                    title="Mark as Rejected"
                                                                                    onClick={() => handleOnRejectedClick(key, images[key])}
                                                                                >
                                                                                    <XCircle className={`w-5 h-5 ${rejectedObject[key] ? 'text-red-800' : 'text-red-500'}`} />
                                                                                    <span className={`text-xs text-center ${rejectedObject[key] ? 'text-red-800 font-semibold' : 'text-red-500'}`}>
                                                                                        Rejected
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            {/* Button placed at the bottom of the full flex container */}
                                                            <div className="mt-auto flex justify-end px-2 pt-4">
                                                                <button
                                                                    type="button"
                                                                    disabled={submittedVehicles.includes(vehicleNo)}
                                                                    onClick={() => {
                                                                        setSelectedVehicleNo(vehicleNo);
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            chooseFromSelectedService: null,


                                                                        })) // Set current vehicleNo
                                                                        setIsModalOpen(true);
                                                                        setIsOpenFor('vehicle')// Open modal
                                                                    }}
                                                                    className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-4 rounded-full bg-[#21A6E9] hover:bg-[#1e94d6]">
                                                                    Action
                                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                                                </button>
                                                            </div>
                                                        </div>


                                                    </div>



                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {
                                    alertInfo.show && (
                                        <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                            {alertInfo.message}
                                        </Alert>
                                    )
                                }

                                <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto" >
                                    <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                        <button
                                            onClick={() => setNextPage(2)}
                                            className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                        >
                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px] scale-x-[-1]" />
                                            Back
                                        </button>
                                        {/* <button
                                                onClick={handleSubmit}
                                                disabled={isSubmitting}
                                                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                                bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                            >
                                                {isSubmitting ? (
                                                    <div className="flex gap-2">
                                                        <ClipLoader size={20} color="#ffffff" />
                                                        <p>Submitting...</p>
                                                    </div>
                                                ) : (
                                                    "Submit"
                                                )}
                                                <img src={rightArrow} alt="Back" className="h-[24px] w-[24px]" />
                                            </button> */}

                                        <button
                                            onClick={() => {
                                                localStorage.removeItem("acceptedObject");
                                                localStorage.removeItem("rejectedObject");
                                                navigate('/NewVendorApproved')
                                            }}
                                            className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                                bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                        >

                                            Filled all Details
                                        </button>

                                        <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                    </div>
                                </div>

                                {modalImage && (
                                    <div
                                        onClick={() => setModalImage(null)}
                                        style={{ backgroundImage: 'linear-gradient(#fefefe36, #656565)' }}
                                        className="fixed inset-0 flex items-center justify-center z-[1000]"
                                    >
                                        <div
                                            onClick={(e) => e.stopPropagation()}
                                            className="bg-white p-4 rounded-lg shadow-lg max-w-[95%] max-h-[95%] overflow-hidden relative"
                                        >
                                            {modalImage.toLowerCase().endsWith('.pdf') ? (
                                                <iframe
                                                    src={modalImage}
                                                    title="PDF Preview"
                                                    className="min-w-full min-h-[90vh] rounded-md object-cover"

                                                />
                                            ) : (
                                                <img
                                                    src={modalImage}
                                                    alt="Preview"
                                                    className="max-w-full max-h-[90vh] rounded-md object-cover"
                                                />
                                            )}

                                            <button
                                                onClick={() => setModalImage(null)}
                                                className="absolute top-2 right-2 text-1xl text-gray-600 hover:text-black focus:outline-none"
                                                title="Close"
                                            >
                                                ❌
                                            </button>
                                        </div>
                                    </div>
                                )}


                            </form>
                        )}
                    </div>
                    {/* )} */}


                    <Modal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        subType={formData.subType}
                        chooseFromSelectedService={formData.chooseFromSelectedService}
                        ReasonOfRejection={formData.ReasonOfRejection}
                        onChange={handleInputChange}
                        handleSubmit={handleSubmit}
                        handleSubmitKYC={handleSubmitKYC}

                        isOpenFor={isOpenFor}
                        selectedVehicleNo={selectedVehicleNo}
                        isSubmitting={isSubmitting}
                        rejectedObject={rejectedObject}
                    />


                    <ConfirmationForDeletion
                        isOpen={openDeletionModal}
                        onClose={() => setOpenDeletionModal(false)}
                        deletionImage={deletionImage}
                        deleteImage={deleteImage}
                    />
                </div>
                <div className=' hidden sm:block w-full mt-[5rem] p-5 max-w-[555px]'>
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img6.png' className='w-[400px] h-[400px]' alt="" />
                </div>
            </div>
        </div>


    );
};

export default ViewAndApproveVendor;


function Modal({ isOpen, onClose, isOpenFor, subType, chooseFromSelectedService, rejectedObject, ReasonOfRejection, onChange, handleSubmit, handleSubmitKYC, isSubmitting }) {
    const [submittingType, setSubmittingType] = useState(null);
    const [rejectionReasons, setRejectionReasons] = useState({});
    const [selectedSubType, setSelectedSubType] = useState(subType || '');

    useEffect(() => {
        if (!isOpen) setSubmittingType(null);
        setRejectionReasons({}); // Reset rejection reasons when modal is closed
    }, [isOpen]);

    const handleSelectChange = (e) => {
        onChange(e); // Update parent
        if (e.target.value !== '') {
            onChange({ target: { name: 'ReasonOfRejection', value: '' } }); // Clear textarea
        }
    };


    // Maintain generalReason as separate state
    const [generalReason, setGeneralReason] = useState("");

    // UseEffect to update ReasonOfRejection any time image or general reason changes
    useEffect(() => {
        const updatedRejectionSummary = Object.entries(rejectionReasons)
            .map(([key, reason]) => {
                const label = key.replace(/([A-Z])/g, " $1").replace(/\b\w/g, (l) => l.toUpperCase());
                return reason ? `• ${label}: ${reason}` : null;
            })
            .filter(Boolean)
            .join("\n");

        let finalReasonOfRejection = updatedRejectionSummary;
        if (generalReason) {
            finalReasonOfRejection += `\n• General: ${generalReason}`;
        }
        finalReasonOfRejection += `\n• No Other Issues`;

        onChange({
            target: {
                name: 'ReasonOfRejection',
                value: finalReasonOfRejection.trim(),
            },
        });
    }, [rejectionReasons, generalReason]);


    const handleTextareaChange = (e, key) => {
        const { value } = e.target;

        // Update local state for individual image reasons
        setRejectionReasons((prev) => {
            const updated = { ...prev, [key]: value };

            // Dynamically build ReasonOfRejection string
            const rejectionSummary = Object.entries(updated)
                .map(([imgKey, reason]) => {
                    const label = imgKey.replace(/([A-Z])/g, " $1").replace(/\b\w/g, (l) => l.toUpperCase());
                    return reason ? `• ${label}: ${reason}` : null;
                })
                .filter(Boolean)
                .join("\n");

            // Push that string into formData via onChange
            onChange({
                target: {
                    name: 'ReasonOfRejection',
                    value: `${rejectionSummary} \n• No Other Issues`,
                },
                target: {
                    name: 'chooseFromSelectedService',
                    value: '',
                },
            });

            return updated;
        });
    };

    const onSubmit = async (type) => {
        setSubmittingType(type);
        isOpenFor === 'KYC' ? await handleSubmitKYC(type) : await handleSubmit(type);
        // await handleSubmit(type);
        setTimeout(() => {
            setSubmittingType(null);
            onClose();
        }, 500);
    };
    const handleSelect = (type) => {
        setSelectedSubType(type);
        onChange({
            target: {
                name: 'subType',
                value: type
            }
        });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed font-satoshi inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            <div className="bg-white py-[42px] px-[50px] h-[90vh] overflow-auto rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-xl font-bold focus:outline-none"
                >
                    &times;
                </button>
                <div className="grid grid-cols-1 pt-[40px] items-center gap-[18px]">

                    <div className="grid grid-cols-1 gap-4 mb-2">
                        {/* Dropdown */}
                        {isOpenFor == "vehicle" && (
                            <div className="flex flex-col">
                                <div className="flex justify-center gap-4">
                                    <button
                                        value="Flat-bed"
                                        onClick={() => handleSelect('Flat-bed')}
                                        className={`px-4 py-2 rounded-md transition border-2 ${selectedSubType === 'Flat-bed'
                                                ? 'bg-blue-500 border-blue-600 text-white'
                                                : 'border-gray-400 hover:bg-blue-500 hover:border-blue-600 hover:text-white'
                                            }`}
                                    >
                                        Flat-bed
                                    </button>
                                    <button
                                        value="Non-flat-bed"
                                        onClick={() => handleSelect('Non-flat-bed')}
                                        className={`px-4 py-2 rounded-md transition border-2 ${selectedSubType === 'Non-flat-bed'
                                                ? 'bg-blue-500 border-blue-600 text-white'
                                                : 'border-gray-400 hover:bg-blue-500 hover:border-blue-600 hover:text-white'
                                            }`}
                                    >
                                        Non-flat-bed
                                    </button>

                                </div>

                                <label htmlFor="chooseFromSelectedService" className="text-sm mt-[3rem] font-medium text-gray-700 mb-1">
                                    Choose Service Type
                                </label>
                                <select
                                    id="chooseFromSelectedService"
                                    name="chooseFromSelectedService"
                                    value={chooseFromSelectedService}
                                    onChange={handleSelectChange}
                                    className="bg-gray-50 h-[4rem] font-satoshi border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2"
                                >
                                    <option value="">Select</option>
                                    <option value="mini">Mini</option>
                                    <option value="medium">Medium</option>
                                    <option value="large">Large</option>
                                </select>
                            </div>)}

                        {/* Textarea */}
                        <div className="flex flex-col space-y-4">
                            <label className="text-sm font-medium text-gray-700 mb-2">
                                Reason of Rejection
                            </label>

                            <div>
                                {Object.keys(rejectedObject).length === 0 ? (
                                    // General reason textarea when no images are rejected
                                    <textarea
                                        rows={2}
                                        placeholder="Add reason..."
                                        onChange={(e) => {
                                            // Update the ReasonOfRejection field with the user's input
                                            onChange({
                                                target: {
                                                    name: 'ReasonOfRejection',
                                                    value: e.target.value,
                                                },
                                            });
                                        }}
                                        className="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2 resize-none focus:ring-red-500 focus:border-red-500"
                                    />
                                ) : (
                                    // Handling individual rejection reasons for each image
                                    <div>
                                        {Object.entries(rejectedObject).map(([key, imageUrl]) => (
                                            <div key={key} className="flex items-start space-x-4">
                                                <img
                                                    src={imageUrl}
                                                    alt={key}
                                                    className="w-16 h-16 object-cover rounded-lg border border-red-400 mt-1"
                                                />
                                                <div className="flex-1">
                                                    <p className="text-sm font-semibold text-gray-800 mb-1">
                                                        {key.replace(/([A-Z])/g, " $1").replace(/\b\w/g, (l) => l.toUpperCase())}
                                                    </p>
                                                    <textarea
                                                        rows={2}
                                                        placeholder="Add reason for this image..."
                                                        value={rejectionReasons[key] || ""}
                                                        onChange={(e) => handleTextareaChange(e, key)} // handle individual image rejection reason
                                                        className="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg p-2 resize-none focus:ring-red-500 focus:border-red-500"
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                        {/* General reason textarea for non-image reasons */}
                                        <textarea
                                            rows={2}
                                            placeholder="Add general reason..."
                                            value={generalReason}
                                            onChange={(e) => setGeneralReason(e.target.value)}
                                            className="w-full bg-gray-50 mt-2 border border-gray-300 text-gray-900 text-sm rounded-lg p-2 resize-none focus:ring-red-500 focus:border-red-500"
                                        />
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>


                    {/* Buttons */}
                    <div className="flex gap-2">
                        {/* Reject */}
                        <button

                            type="button"
                            onClick={() => onSubmit('not_approved')}
                            disabled={
                                submittingType !== null ||
                                (
                                    chooseFromSelectedService === '' &&  // if no service type selected (only for non-KYC)
                                    ReasonOfRejection.trim() === ''      // no reason provided
                                )
                            }
                            className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full disabled:bg-gray-300 disabled:cursor-not-allowed"
                        >
                            {submittingType === 'not_approved' ? (
                                <div className="flex gap-2 items-center">
                                    <ClipLoader size={20} color="#ffffff" />
                                    <p>Submitting...</p>
                                </div>
                            ) : (
                                "Reject"
                            )}
                        </button>

                        {/* Accept */}
                        <button
                            type="button"
                            onClick={() => onSubmit('approved')}
                            disabled={
                                Object.entries(rejectedObject).length !== 0 ||
                                submittingType !== null ||
                                !(isOpenFor === "KYC") &&
                                (ReasonOfRejection !== '' || chooseFromSelectedService === '')
                            }
                            className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                            bg-[#21A6E9] hover:bg-[#1e94d6] disabled:bg-gray-300 disabled:cursor-not-allowed"
                        >
                            {submittingType === 'approved' ? (
                                <div className="flex gap-2 items-center">
                                    <ClipLoader size={20} color="#ffffff" />
                                    <p>Submitting...</p>
                                </div>
                            ) : (
                                "Accept"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}


function ConfirmationForDeletion({ isOpen, onClose, deleteImage, deletionImage }) {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
                <h2 className="text-lg font-semibold mb-2 text-red-500"> Delete Image </h2>
                <p className="text-gray-600 text-sm mb-6">
                    You want to Delete Image by Vendor?
                </p>
                <div className="flex justify-around text-sm">
                    <button
                        className="text-gray-700 hover:underline"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="text-blue-600 hover:underline font-medium"
                        onClick={() => {
                            onClose();
                            deleteImage(deletionImage)
                        }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>)
}





